import styled from 'styled-components'
import { gray, grayDark } from '@bufferapp/ui/style/colors'

export const Button = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  color: ${gray};

  &:hover {
    color: ${grayDark};
  }
`
